import { createFastContext } from '@rst/libs-ts'

export const { Provider: ButtonCtxProvider, useCtx: useButtonCtx } =
	createFastContext<{
		forceShowAllBlocks?: boolean
		setForceShowAllBlocks?: () => void
	}>({})
